import React from "react";
import { useTranslation } from "react-i18next";
import * as _ from "lodash";
import MainHeader from "../../components/common/MainHeader";
import ReportExportButton from "../../components/common/ReportExportButton";
import { URL_REPORT } from "../../constance/urls";
import { Layout, Form, DatePicker, Row, Col, Tooltip, Input, Select } from "antd";
import { Content } from "antd/es/layout/layout";
import Title from "antd/es/typography/Title";
import { DATE_FORMAT, HUMAN_DATE_FORMAT } from "../../constance/strings";
import dayjs from "dayjs";
import { WOOD_IMPORT_GRADE_DISPLAY } from "../../constance/dataTypes";

export default function PostBakingWasteWoodSummaryReportView() {

  const { t } = useTranslation()
  const { RangePicker } = DatePicker;
  const [form] = Form.useForm();
  const oven = Form.useWatch('oven', form);
  const dateRange = Form.useWatch('dateRange', form);
  const gradeFilter = Form.useWatch('gradeFilter', form)
  const haveDateRange = _.get(dateRange, 0, null) && _.get(dateRange, 1, null)

  return (
    <div>
      <Layout>
        <Content style={{ margin: '24px', marginTop: '7em' }}>
          <MainHeader />
          <Title level={2}>{t('menus.report_menus.waste_woods.post_baking_waste_wood_summary')}</Title>

          <Form form={form}>
            <Row gutter={16} justify={'center'}>
              <Col sm={24} md={24} lg={6} style={{width: '100%'}}>
                <Form.Item label={t('post_baking_waste_wood_count.group_date')} name='dateRange'>
                  <RangePicker
                    format={HUMAN_DATE_FORMAT}
                    placeholder={[
                      t('searchs.placeholders.startDate'),
                      t('searchs.placeholders.endDate'),
                    ]}
                    style={{ width: '100%' }}
                  />
                </Form.Item>
              </Col>
              <Col sm={24} md={24} lg={6} style={{ width: '100%' }}>
                <Form.Item label={t('post_baking_waste_wood_count.oven_no')} name={'oven'}>
                  <Input placeholder={t('all')} allowClear type="number" />
                </Form.Item>
              </Col>
              <Col sm={24} md={24} lg={6} style={{ width: '100%' }}>
                <Form.Item label={t('wood_imports.grade')} name={'gradeFilter'}>
                  <Select
                    options={[
                      { value: 'all', key: 'all', label: t('all') },
                      ...WOOD_IMPORT_GRADE_DISPLAY.map(grade => { return { value: grade, key: grade, label: grade.toLocaleUpperCase() } })            
                    ]}
                    defaultValue={'all'}
                  />
                </Form.Item>
              </Col>
            </Row>
          </Form>

          <Tooltip title={!haveDateRange ? t('searchs.placeholders.date') : ""}>
            <span>
              <ReportExportButton
                url={`${URL_REPORT.POST_BAKING_WASTE_WOOD_SUMMARY_REPORT}pdf/`}
                title={t('menus.report_menus.waste_woods.post_baking_waste_wood_summary')}
                type='pdf'
                disabled={!haveDateRange}
                params={{
                  oven: oven,
                  date_after: _.get(dateRange, 0, null) ? dayjs(dateRange[0]).format(DATE_FORMAT) : null,
                  date_before: _.get(dateRange, 1, null) ? dayjs(_.get(dateRange, 1)).format(DATE_FORMAT) : null,
                  grade: gradeFilter == 'all' ? null : gradeFilter,
                }}/>
            </span>
          </Tooltip>
          <Tooltip title={!haveDateRange ? t('searchs.placeholders.date') : ""}>
            <span>
              <ReportExportButton
                url={`${URL_REPORT.POST_BAKING_WASTE_WOOD_SUMMARY_REPORT}excel/`}
                title={t('menus.report_menus.waste_woods.post_baking_waste_wood_summary')}
                type='excel'
                disabled={!haveDateRange}
                params={{
                  oven: oven,
                  date_after: _.get(dateRange, 0, null) ? dayjs(dateRange[0]).format(DATE_FORMAT) : null,
                  date_before: _.get(dateRange, 1, null) ? dayjs(_.get(dateRange, 1)).format(DATE_FORMAT) : null,
                  grade: gradeFilter == 'all' ? null : gradeFilter,
                }}/>
            </span>
          </Tooltip>

        </Content>
      </Layout>
    </div>
  )
}

